import ScheduleActivityCard from './ScheduleActivityCard';

export default ScheduleActivityCard;
